import { getFormData } from '../../../helpers';

/**
 * Gets updated OwnHome value
 * @param {Object} formData - Form data object
 * @returns {String} The processed OwnHome value
 */
export function getOwnHomeValue(formData) {
	if (!formData) {
		formData = getFormData();
	}

	return formData.OwnHome === 'Authorized' ? 'Yes' : formData.OwnHome;
}
